import React from 'react';

import ExistingMemberSearchFilterContextProvider from './state/existingMemberSearch/ExistingMemberSearchFilterContextProvider';
import OmrContextProvider from './state/omr/OmrContextProvider';
import AddressBookContextProvider from './state/omr/AddressBookContextProvider';
//TODO: Remove temp person context provider when we have security and person logged in info solidified
import TempPersonContextProvider from './state/tempPersonData/TempPersonContextProvider';
import PersonContextProvider from './state/landingPages/person/PersonContextProvider';
import RegisteredMembersContextProvider from './state/registeredMembers/RegisteredMembersContextProvider';
import ChildrenContextProvider from './state/landingPages/children/ChildrenContextProvider';
import LandingPageContextProvider from './state/landingPages/LandingPageContextProvider';
import PersonParentChildContextProvider from './state/landingPages/personParentChild/PersonParentChildContextProvider';
import OmrBackButtonContextProvider from './state/omrBackButton/OmrBackButtonContextProvider';
import MemberRegistrationContextProvider from './state/memberRegistration/MemberRegistrationContextProvider';
import MemberRegistrationOfferingsContextProvider from './state/memberRegistrationOfferings/MemberRegistrationOfferingsContextProvider';

import OrgUnitContextProvider from '@usas/ui-web/state/orgUnit/OrgUnitContextProvider';
import ContactRelationshipTypesContextProvider from '@usas/ui-web/state/contactRelationshipType/ContactRelationshipTypesContextProvider';
import AddressTypeContextProvider from '@usas/ui-web/state/addressType/AddressTypeContextProvider';
import PhoneTypeContextProvider from '@usas/ui-web/state/phoneType/PhoneTypeContextProvider';
import OfferingTypesContextProvider from '@usas/ui-web/state/offeringTypes/OfferingTypesContextProvider';
import HispanicOrLatinoTypeContextProvider from '@usas/ui-web/state/hispanicOrLatinoType/HispanicOrLatinoTypeContextProvider';
import EthnicityTypeContextProvider from '@usas/ui-web/state/ethnicityType/EthnicityTypeContextProvider';
//import DisabilityTypeContextProvider from '@usas/ui-web/state/disabilityType/DisabilityTypeContextProvider';
import MemberRegistrationHistoryContextProvider from '@usas/ui-web/state/offeringTypes/MemberRegistrationHistoryContextProvider';
import CompetitonGenderTypeContextProvider from '@usas/ui-web/state/competitionGender/CompetitionGenderTypeContextProvider';
import GenderIdentityTypeContextProvider from '@usas/ui-web/state/genderIdentity/GenderIdentityTypeContextProvider';
import RouteCodeValueContextProvider from '@usas/ui-web/state/routeCode/RouteCodeValueContextProvider';
import LeftNavModalContextProvider from '@usas/ui-web/state/leftNavModal/LeftNavModalContextProvider';
import PersonGeneralContextProvider from '@usas/ui-web/state/personGeneral/PersonGeneralContextProvider';
import RenewalOptionContextProvider from '@usas/ui-web/state/renewalOption/RenewalOptionContextProvider';
import BasePersonContextProvider from '@usas/ui-web/state/personBase/BasePersonContextProvider';
import BasePersonFiltersContextProvider from '@usas/ui-web/state/personBase/BasePersonFiltersContextProvider';
import PersonAcknowledgementInfoContextProvider from '@usas/ui-web/state/personAcknowledgementInfo/PersonAcknowledgementInfoContextProvider';
import PersonAcknowledgementInfoPageViewContextProvider from '@usas/ui-web/state/personAcknowledgementInfo/PersonAcknowledgementInfoPageViewContextProvider';
import PersonAcknowledgementAddAFamilyMemberContextProvider from '@usas/ui-web/state/personAcknowledgementAddAFamilyMember/PersonAcknowledgementAddAFamilyMemberContextProvider';
import PersonParentChildFamilyContactContextProvider from '@usas/ui-web/state/personParentChildFamilyContact/PersonParentChildFamilyContactContextProvider';

const AppStateContextProviders = ({ children }) => (
  <MemberRegistrationContextProvider>
    <MemberRegistrationOfferingsContextProvider>
      <PersonParentChildFamilyContactContextProvider>
        <OmrBackButtonContextProvider>
          <PersonAcknowledgementAddAFamilyMemberContextProvider>
            <BasePersonContextProvider>
              <BasePersonFiltersContextProvider>
                <PersonAcknowledgementInfoContextProvider>
                  <PersonAcknowledgementInfoPageViewContextProvider>
                    <RenewalOptionContextProvider>
                      <LeftNavModalContextProvider>
                        <TempPersonContextProvider>
                          <OrgUnitContextProvider>
                            <OmrContextProvider>
                              <ContactRelationshipTypesContextProvider>
                                <PhoneTypeContextProvider>
                                  <AddressTypeContextProvider>
                                    <RouteCodeValueContextProvider>
                                      <ExistingMemberSearchFilterContextProvider>
                                        <OfferingTypesContextProvider>
                                          <HispanicOrLatinoTypeContextProvider>
                                            <EthnicityTypeContextProvider>
                                              <CompetitonGenderTypeContextProvider>
                                                <GenderIdentityTypeContextProvider>
                                                  {/* <DisabilityTypeContextProvider> */}
                                                  <MemberRegistrationHistoryContextProvider>
                                                    <PersonGeneralContextProvider>
                                                      <AddressBookContextProvider>
                                                        <LandingPageContextProvider>
                                                          <PersonParentChildContextProvider>
                                                            <ChildrenContextProvider>
                                                              <PersonContextProvider>
                                                                <RegisteredMembersContextProvider>
                                                                  {children}
                                                                </RegisteredMembersContextProvider>
                                                              </PersonContextProvider>
                                                            </ChildrenContextProvider>
                                                          </PersonParentChildContextProvider>
                                                        </LandingPageContextProvider>
                                                      </AddressBookContextProvider>
                                                    </PersonGeneralContextProvider>
                                                  </MemberRegistrationHistoryContextProvider>
                                                  {/* </DisabilityTypeContextProvider> */}
                                                </GenderIdentityTypeContextProvider>
                                              </CompetitonGenderTypeContextProvider>
                                            </EthnicityTypeContextProvider>
                                          </HispanicOrLatinoTypeContextProvider>
                                        </OfferingTypesContextProvider>
                                      </ExistingMemberSearchFilterContextProvider>
                                    </RouteCodeValueContextProvider>
                                  </AddressTypeContextProvider>
                                </PhoneTypeContextProvider>
                              </ContactRelationshipTypesContextProvider>
                            </OmrContextProvider>
                          </OrgUnitContextProvider>
                        </TempPersonContextProvider>
                      </LeftNavModalContextProvider>
                    </RenewalOptionContextProvider>
                  </PersonAcknowledgementInfoPageViewContextProvider>
                </PersonAcknowledgementInfoContextProvider>
              </BasePersonFiltersContextProvider>
            </BasePersonContextProvider>
          </PersonAcknowledgementAddAFamilyMemberContextProvider>
        </OmrBackButtonContextProvider>
      </PersonParentChildFamilyContactContextProvider>
    </MemberRegistrationOfferingsContextProvider>
  </MemberRegistrationContextProvider>
);

export default AppStateContextProviders;